import { useCallback, useState } from 'react';
import { MODAL_TYPES, type ModalType } from '../constants/customers.constants';
import { CUSTOMER_ACTION_VALUES, type CustomerActionValue } from '../components/CustomerActionsDropdown';

export function useCustomerModals() {
    const [activeModal, setActiveModal] = useState<ModalType>(null);

    const handleActionSelect = useCallback((action: CustomerActionValue) => {
        const modalMap: Record<CustomerActionValue, ModalType> = {
            [CUSTOMER_ACTION_VALUES.ADD_TAG]: MODAL_TYPES.ADD_TAG,
            [CUSTOMER_ACTION_VALUES.REMOVE_TAG]: MODAL_TYPES.REMOVE_TAG,
            [CUSTOMER_ACTION_VALUES.GRANT_PRODUCT_ACCESS]: MODAL_TYPES.GRANT_PRODUCT,
            [CUSTOMER_ACTION_VALUES.GRANT_AFFILIATE_ACCESS]: MODAL_TYPES.GRANT_AFFILIATE,
            [CUSTOMER_ACTION_VALUES.ADD_TO_EMAIL_FLOW]: MODAL_TYPES.ADD_TO_FLOW,
            [CUSTOMER_ACTION_VALUES.DELETE_CUSTOMERS]: MODAL_TYPES.DELETE_CUSTOMERS,
            [CUSTOMER_ACTION_VALUES.DOWNLOAD_CSV]: MODAL_TYPES.EXPORT_CSV,
        };
        setActiveModal(modalMap[action] ?? null);
    }, []);

    const handleModalClose = useCallback(() => {
        setActiveModal(null);
    }, []);

    return {
        activeModal,
        handleActionSelect,
        handleModalClose,
    };
}
